export const KeysUpdated = () => (
    <div class="box">
        <h1 class="title">Key settings</h1>
        <p>Your keys have been Saved!</p>
        <button className="button is-primary" onClick={() => window.location.href = 'https://web.peerbrain.net/profile'}>Home</button>
    </div>
    );